<section class="section">
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <h1 class="title font-weight-bold text-dark text-center">
          {{ 'Fee Structure' | translate }}
        </h1>
      </div>
    </div>
  </div>

  <div class="container-fluid tw-pt-[30px]">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 class="p-text-h3 tw-mb-5">{{ 'feeStructurePage.feesForInvestors' | translate }}</h2>

        <h3 class="p-text-p tw-font-body tw-font-semibold">{{ 'feeStructurePage.ecf' | translate }}</h3>
        <ul class="tw-pl-5">
          <li>{{ 'feeStructurePage.investorsNoFee' | translate }}</li>
        </ul>

        <h3 class="p-text-p tw-mt-8 tw-font-body tw-font-semibold">{{ 'feeStructurePage.tcf' | translate }}</h3>
        <ul class="tw-pl-5">
          <li>{{ 'feeStructurePage.investorsNoFee' | translate }}</li>
        </ul>

        <h3 class="p-text-p tw-mt-8 tw-font-body tw-font-semibold">
          {{ 'feeStructurePage.pstx' | translate }}
        </h3>
        <ul class="tw-pl-5">
          <li>
            <a [routerLink]="['/learn/trade/pstx-fee-structure']"
              >{{ 'feeStructurePage.viewSecondaryMarketFees' | translate }} →</a
            >
          </li>
        </ul>

        <hr />

        <h2 class="p-text-h3 tw-mb-5">{{ 'feeStructurePage.feesForIssuers' | translate }}</h2>
        <p>{{ 'feeStructurePage.issuersIntro' | translate }}</p>
        <ul class="tw-space-y-2.5 tw-pl-5">
          <li>
            <a [routerLink]="['/learn/raise/types-of-fees-for-issuers']"
              >{{ 'feeStructurePage.ecfFundraisingFees' | translate }} →</a
            >
          </li>
          <li>
            <a [routerLink]="['/learn/token-issue/tcf-fee-structure']"
              >{{ 'feeStructurePage.tcfFundraisingFees' | translate }} →</a
            >
          </li>
          <li>
            <a [routerLink]="['/learn/trade/pstx-fee-structure']"
              >{{ 'feeStructurePage.pstxTradingFees' | translate }} →</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
